import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Jane Smith",
        title: "Roofing Specialist",
        biography: "Jane Smith is a highly skilled roofing specialist known for her expertise in roof installation, repair, and maintenance. With extensive experience in the roofing industry, she has worked on a wide variety of roofing projects, ensuring top-quality workmanship and client satisfaction. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "555-123-4567",
            email: "jane.smith@example.com",
            website: "www.janesmithroofing.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Roof Installer",
            "Roof Repair Specialist",
            "Gutter Installation Expert",
            "Roof Maintenance Technician",
            "Roofing Consultant"
        ],
        skills: [
            { id: 1, title: "Roof Installation", progress: 95 },
            { id: 2, title: "Roof Repair", progress: 90 },
            { id: 3, title: "Gutter Installation", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Michael Johnson",
        title: "Roof Installation Expert",
        biography: "Michael Johnson is an experienced roof installation expert with a proven track record in delivering exceptional roofing solutions. With expertise in installing durable and high-quality roofs, he has worked on numerous residential and commercial projects, always ensuring the best results and customer satisfaction.",
        contacts: {
            phone: "555-234-5678", 
            email: "michael.johnson@example.com",
            website: "www.michaeljohnsonroofing.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Roof Installer",
            "Roof Installation Manager",
            "Roof Repair Specialist",
            "Project Coordinator"
        ],
        skills: [
            { id: 1, title: "Roof Installation", progress: 98 },
            { id: 2, title: "Project Management", progress: 90 },
            { id: 3, title: "Customer Relations", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Emily Davis",
        title: "Roof Repair Specialist",
        biography: "Emily Davis is a skilled roof repair specialist with extensive experience in diagnosing and fixing roofing issues. Known for her attention to detail and dedication, she has repaired countless roofs, restoring their strength and durability, and ensuring long-lasting results for homeowners and businesses alike.",
        contacts: {
            phone: "555-345-6789",
            email: "emily.davis@example.com",
            website: "www.emilydavisroofing.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Roof Repair Specialist",
            "Roof Maintenance Expert",
            "Emergency Roof Repair Technician",
            "Leak Detection Specialist"
        ],
        skills: [
            { id: 1, title: "Roof Leak Repairs", progress: 95 },
            { id: 2, title: "Shingle Replacement", progress: 90 },
            { id: 3, title: "Emergency Roof Repairs", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Robert Brown",
        title: "Gutter Installation Specialist",
        biography: "Robert Brown is a seasoned gutter installation specialist with years of experience in providing high-quality, reliable gutter systems for homes and businesses. Known for his precision and efficiency, Robert ensures that each installation is seamless, protecting properties from water damage and enhancing overall functionality.",
        contacts: {
            phone: "555-678-1234",
            email: "robert.brown@example.com",
            website: "www.robertbrownroofing.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Gutter Installation Specialist",
            "Gutter Repair Expert",
            "Seamless Gutter Installer",
            "Downspout Specialist"
        ],
        skills: [
            { id: 1, title: "Gutter Installation", progress: 95 },
            { id: 2, title: "Seamless Gutter Systems", progress: 90 },
            { id: 3, title: "Downspout Repair", progress: 85 }
        ]
    }

];

export default team;